enum JobWorkerStatus {
	Shortlisted = 5,
	SentToWorker = 10,
	WorkerNotInterested = 15,
	WorkerInterested = 18,
	SentToContact = 20,
	ContactNotInterested = 25,
	ContactInterested = 28,
	InterviewOne = 40,
	InterviewTwo = 50,
	Rejected = 70,
	Offer = 80,
	Accepted = 85,
	Placed = 90,

}

export default JobWorkerStatus;